<template>
  <div class="aboutNews">
    <div class="newsList">
      <div class="list" v-for="item in lists" :key="item.id" @click="goDetail(item.link)">
        <div class="imgArea">
          <img :src="item.url" alt="">
        </div>
        <div class="textArea">
          <div class="compTitleTwo">{{ item.title }}</div>
          <div class="compText">{{ item.text }}</div>
          <div class="time">
            <div>{{ item.time }}</div>
            <div><img src="../assets/images/rightG.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutNews',
  components: {},
  data() {
    return {
      lists: [
        {
          id: '1',
          title: '壹心云服保险中介签约突破四百家——预计全年平台保费规模达3000亿元',
          text: '9月27日，壹心云服迎来了快速发展中的里程碑事件。壹心云服务平台在全面升级后的短短六个月时间里，在北京、上海、山东等近20个省份内全面落地。',
          url: require('../assets/images/picture_news_01.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU2MDYxOTMxNQ==&mid=2247489258&idx=1&sn=5e47132fc9c4f41e52b13d8a907846ab&chksm=fc041cb6cb7395a0655980c8d6fe95b379262cab218d36ecb49cfa55347fdf595b0e6d7ef27f&token=197442591&lang=zh_CN#rd',
          time: '2021.09.29'
        },
        {
          id: '2',
          title: '热烈祝贺北京大区ACP产品协同业务单月保费规模破1000万',
          text: '壹心科技始终坚定不移的推动行业升级，在业内首创中介协同发展的 “ACP”新模式。9月，北京大区ACP产品协同业务单月保费规模破千万。',
          url: require('../assets/images/picture_news_02.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU2MDYxOTMxNQ==&mid=2247489258&idx=2&sn=d9d9ff0c03c25dac767d1a7df4410c85&chksm=fc041cb6cb7395a0dc6fff102d1ab9e9816353e77dd8e9d1c1587c161ec19ca528edd80d71c9&token=197442591&lang=zh_CN#rd',
          time: '2021.09.29'
        },
        {
          id: '3',
          title: '热烈祝贺北京壹心壹翼科技有限公司成功完成近亿元B轮融资',
          text: '北京壹心壹翼科技有限公司（以下简称壹心科技）作为保险科技头部企业于7月顺利完成近亿元B轮融资。此次投资方为国投创业领投，福建莆田新佳骏跟投。',
          url: require('../assets/images/picture_news_03.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU2MDYxOTMxNQ==&mid=2247489115&idx=2&sn=a84469ee8343d08ce4c3cfddd67ac014&chksm=fc041c07cb7395112300a67439881b9665021cdf0d2fff931dd0c94b080683e7618b72d8093a&token=197442591&lang=zh_CN#rd',
          time: '2021.09.06'
        },
        {
          id: '4',
          title: '北京壹心壹翼科技有限公司与上海保交所、中银保信达成战略合作',
          text: '随着监管对保险中介行业信息化的强化管理，对MGA，独立代理人的创新发展探索，北京壹心壹翼科技有限公司（以下简称”壹心科技）不忘“用我们的平台，让保险更简单…',
          url: require('../assets/images/picture_news_04.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU2MDYxOTMxNQ==&mid=2247489115&idx=3&sn=f9906a19e05b585f0549b7eeaf25b4d0&chksm=fc041c07cb73951179ce2478625f01b4dae935a548d19091323dbd72864d5c40cba798507017&token=197442591&lang=zh_CN#rd',
          time: '2021.09.06'
        },
        {
          id: '5',
          title: '壹心保险服务北京大区高端客户私宴沙龙圆满结束',
          text: '7月18日晚，壹心保险服务北京大区（以下简称北京大区）举办高端客户私宴沙龙。本次沙龙以VIP客户为邀约对象，不仅为经纪团队创造了答谢客户的机会，也通过面对…',
          url: require('../assets/images/picture_news_05.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU2MDYxOTMxNQ==&mid=2247488862&idx=2&sn=50a63d018735a39448c89fb352da6e2f&chksm=fc041f02cb739614fc3918dfe6c25897e7f645b770a620479cb7f4af0b50c59663f5bf09209a&token=197442591&lang=zh_CN#rd',
          time: '2021.07.21'
        },
      ]
    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {
    goDetail(val) {
      window.open(val)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutNews {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 30px;
  }

  .newsList {
    .list {
      display: flex;
      margin-bottom: 40px;
      width: 1024px;
      height: 172px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

      .imgArea {
        width: 304px;
        height: 172px;
        background-color: #DFDFDF;

        img {
          width: 304px;
          height: 172px;
        }
      }

      .textArea {
        padding: 24px;
        background-color: #FBFBFB;
        flex: 1;
      }

      .compText {
        margin-top: 12px;
      }

      .time {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        color: #666666;
        font-size: 16px;

        img {
          width: 30px;
        }
      }
    }
  }

}
</style>